export default __webpack_public_path__ + "static/media/fea1.ae7b53ed.jpg";